import {
  LoyaltyHomepage,
  PersonalizedHomepage,
  useIsLoyaltyHomepageEnabled,
  useIsPersonalizedHomepageEnabled,
} from '@fhs/loyalty-homepage';
import { MqSwitch, createMqStyles } from '@fhs/ui';

import { HomeAlert } from './home-alert';
import { HomeCard } from './home-card';
import { ScreenHomeDesktop } from './screen-home-desktop';
import { ScreenHomeMobile } from './screen-home-mobile';
import { ScreenHomeProps } from './types';

export { ScreenHomeProps } from './types';

export function ScreenHome(props: ScreenHomeProps) {
  const mqStyles = useMqStyles();
  const isPersonalizedHomepageEnabled = useIsPersonalizedHomepageEnabled();
  const isLoyaltyHomepageEnabled = useIsLoyaltyHomepageEnabled();

  if (isPersonalizedHomepageEnabled) {
    return (
      <PersonalizedHomepage
        legacyHomepageAlert={
          Boolean(props.alert?.text) && (
            <HomeAlert text={props.alert.text} link={props.alert.link} />
          )
        }
        legacyHomeCard={
          <HomeCard
            style={mqStyles.container}
            logReorderCardPress={props.logReorderCardPress}
            displayedOrder={props.displayedOrder}
            displayedOrderCardLoading={props.displayedOrderCardLoading}
            redirectPath={props.redirectPath}
            onReorder={props.onReorder}
            reorderLoading={props.reorderLoading}
            isLoadingChallenges={props.isLoadingChallenges}
            loyaltyUserReady={props.loyaltyUserReady}
            isDesktop={props.isDesktop}
            challengeHomeCardProps={props.challengeHomeCardProps}
            noEmptyState
          />
        }
      />
    );
  }

  if (isLoyaltyHomepageEnabled) {
    return (
      <LoyaltyHomepage
        {...props}
        legacyHomepageAlert={
          Boolean(props.alert?.text) && (
            <HomeAlert text={props.alert.text} link={props.alert.link} />
          )
        }
        legacyHomeCard={
          <HomeCard
            style={mqStyles.container}
            logReorderCardPress={props.logReorderCardPress}
            displayedOrder={props.displayedOrder}
            displayedOrderCardLoading={props.displayedOrderCardLoading}
            redirectPath={props.redirectPath}
            onReorder={props.onReorder}
            reorderLoading={props.reorderLoading}
            isLoadingChallenges={props.isLoadingChallenges}
            loyaltyUserReady={props.loyaltyUserReady}
            isDesktop={props.isDesktop}
            challengeHomeCardProps={props.challengeHomeCardProps}
            doublePointsMondayBanner={props.doublePointsMondayBanner}
            noEmptyState
          />
        }
      />
    );
  }

  return (
    <MqSwitch
      $base={() => <ScreenHomeMobile {...props} />}
      $gteDesktop={() => <ScreenHomeDesktop {...props} />}
    />
  );
}

const useMqStyles = createMqStyles({
  container: {
    $base: {
      maxWidth: 1400,
      width: '100%',
      marginHorizontal: 'auto',
      paddingHorizontal: 16,
    },
    $gteDesktop: {
      paddingHorizontal: 32,
    },
  },
});
